import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import infracoes_api from '../../../../api/infracoes_api';

// Components
import CartaoFicha from '../../FichaImpressaoCompleta/_components/CartaoFicha';
import RodapeEmissor from '../../FichaImpressaoCompleta/_components/RodapeEmissor';
import AvisoItemSemConteudo from '../../FichaImpressaoCompleta/_components/AvisoItemSemConteudo';

const pageStylePdfSeparado = `
@page { size: auto; margin: 0mm; }
@media print { body { -webkit-print-color-adjust: exact; } }
@media print {
  @page { size:A4; margin:0; }
  .noPrint { display:none; }
  /* Sem isso a folha (proporção A4) some do header do CartaoFicha e empurra a página inteira pra
     próxima folha na impressão — título isolado numa folha, imagem isolada na outra. */
  .paginaPdfSeparado { max-height: 22cm; width: auto; }
  .cartaoPaginaSeparada:not(:first-child) { page-break-before: always; }
}
`;

// O backend rasteriza o PDF em PNG por página (mesmo motor de BoletoInfracao/SolicitarBoletoPng) —
// aqui é <img>, sem o visualizador nativo de PDF do navegador (barra escura, zoom, nome em GUID).
export default function FichaPdfSeparada({ hash, parametrizacaoHash, titulo, numeroInfracao }) {
    const [paginas, setPaginas] = useState(null);
    const [erro, setErro] = useState(null);
    const ref = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        documentTitle: titulo ?? "Documento",
        pageStyle: pageStylePdfSeparado
    });

    useEffect(() => {
        infracoes_api.GetImpressaoDocumentoSeparadoPng(hash, parametrizacaoHash)
            .then(({ data }) => {
                if (data?.length)
                    setPaginas(data);
                else
                    setErro("Não foi possível gerar a visualização do documento.");
            })
            .catch(error => setErro(error?.message ?? "Não foi possível gerar o documento."));
    }, [hash, parametrizacaoHash]);

    if (erro)
        return <div className="p-3"><AvisoItemSemConteudo titulo={titulo ?? "Documento"} mensagem={erro} className="noPrint" /></div>;

    if (!paginas) return <></>; 
    
    return (
        <div className="d-flex flex-column p-3">
            <div className="noPrint d-flex justify-content-end mb-3">
                <Button color="danger" onClick={handlePrint}>
                    <FontAwesomeIcon icon={faFilePdf} /> Imprimir
                </Button>
            </div>
            <div ref={ref}>
                {/* Um CartaoFicha por página, no mesmo padrão da impressão completa: toda folha sai
                    com logos e título, em vez do cabeçalho aparecer só na primeira. */}
                {paginas.map((base64, index) => (
                    <CartaoFicha
                        key={index}
                        titulo={titulo ?? "Documento"}
                        className="cartaoPaginaSeparada mb-3"
                    >
                        <div className="d-flex justify-content-center">
                            <img
                                className="paginaPdfSeparado mt-3"
                                src={`data:image/png;base64,${base64}`}
                                alt={`${titulo ?? "Documento"} - página ${index + 1}`}
                                style={{ width: "100%", maxWidth: "750px", height: "auto", objectFit: "contain" }}
                            />
                        </div>
                        <RodapeEmissor numeroInfracao={numeroInfracao} />
                    </CartaoFicha>
                ))}
            </div>
        </div>
    );
}
